export const UI_6_2_tableRow1 = [
  [
    {
      cellName: "매수공장명",
      id: "plantInloName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "에너지종류",
      id: "engDescr",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산일",
      id: "calcYm",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "매수/매도",
      id: "sinkSource",
      row: 1,
      col: 1,
      style: { width: "6%" },
    },
    {
      cellName: "입출금상태",
      id: "deawiStCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산금액",
      id: "clacAmt",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래량",
      id: "trnsVol",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래량요금",
      id: "trnsVolChrg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "사용단가",
      id: "useUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "기준단가",
      id: "baseUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "연동단가",
      id: "linkUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "기본요금",
      id: "basicChrg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산상태",
      id: "calcStCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
  ]
]

export const UI_6_2_tableRow2 = [
  [
    {
      cellName: "매도공장명",
      id: "plantInloName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "에너지종류",
      id: "engDescr",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산일",
      id: "calcYm",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "매수/매도",
      id: "sinkSource",
      row: 1,
      col: 1,
      style: { width: "6%" },
    },
    {
      cellName: "입출금상태",
      id: "deawiStCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산금액",
      id: "clacAmt",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래량",
      id: "trnsVol",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래량요금",
      id: "trnsVolChrg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "사용단가",
      id: "useUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "기준단가",
      id: "baseUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "연동단가",
      id: "linkUnitPrice",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "기본요금",
      id: "basicChrg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "정산상태",
      id: "calcStCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
  ]
]


export const UI_6_2_gridData = [
  {
    plantPid: "F010001",
    energyTid: "E01",
    clacYm: "202306",
    sinkSource: "SINK",
    deawiStCd: "4509",
    clacAmt: 123000,
    trnsVol: 500,
    trnsVolChrg: 2311,
    useUnitPrice: 100,
    baseUnitPrice: 200,
    linkUnitPrice: 300,
    basicChrg: 80,
    clacStCd: "4409"
  }
]